import React from "react";
import styles from "./Review.module.scss";
import { UserProfileIcon, CalenderIcon } from "../icons/icons";

const Review = ({
  patient = "boy",
  provider,
  date,
  time,
  practiceLocation,
  onBack,
  //onBook
}) => {
  return (
    <div className={styles.reviewContainer}>
      <div className={styles.summaryList}>
        <div className={styles.summaryItem}>
          <div className={styles.IconContainer}>
            <UserProfileIcon />
          </div>
          <div className={styles.summaryItemContent}>
            <div className={styles.label}>Patient</div>
            <div className={styles.value}>Andrew Scone</div>
          </div>
        </div>
        <div className={styles.summaryItem}>
          <div className={styles.IconContainer}>
            <UserProfileIcon />
          </div>
          <div className={styles.summaryItemContent}>
            <div className={styles.label}>Provider</div>
            <div className={styles.value}>Dr Ethel Boykin</div>
          </div>
        </div>
        <div className={styles.summaryItem}>
          <div className={styles.IconContainer}>
            <CalenderIcon color="#6A421C"/>
          </div>
          <div className={styles.summaryItemContent}>
            <div className={styles.label}>Date</div>
            <div className={styles.value}>Mon, 27th April, 2025</div>
          </div>
        </div>
        <div className={styles.summaryItem}>
          <div className={styles.IconContainer}>
            <CalenderIcon color="#6A421C" />
          </div>
          <div className={styles.summaryItemContent}>
            <div className={styles.label}>Time</div>
            <div className={styles.value}>8:00am - 9:00am</div>
          </div>
        </div>
        <div className={styles.summaryItem}>
          <div className={styles.IconContainer}>
            <CalenderIcon color="#6A421C"/>
          </div>
          <div className={styles.summaryItemContent}>
            <div className={styles.label}>Practice Location</div>
            <div className={styles.value}>AOA Clinic</div>
          </div>
        </div>
      </div>
      <div className={styles.buttonRow}>
        <button className={styles.backButton} onClick={onBack}>
          Back
        </button>
        <button className={styles.bookButton}>Book session</button>
      </div>
    </div>
  );
};

export default Review;
